import $ from 'jquery';

$(document).ready(() => {
	const threshold = 200;
	const $header = $('header.header');
	$(window).on('scroll', () => {
		if (window.scrollY > threshold) {
			$header.addClass('in');
		} else {
			$header.removeClass('in');
		}
	});
	$('.menu__toggle').click(function (e) {
		e.preventDefault();
		$(this).toggleClass('is-active');
		$('nav#mobile').toggleClass('is-active');
	});
});

const hasBanner = () => {
	return document.querySelectorAll('div[role="dialog"][aria-label*="BANNER"]').length > 0;
};

window.addEventListener('klaviyoForms', (e) => {
	if (e.detail.type === 'open') {
		setTimeout(() => {
			if (hasBanner()) {
				$('body').addClass('klaviyo-open');
			}
		}, 100);
	} else if (e.detail.type === 'close') {
		if (!hasBanner()) {
			$('body').removeClass('klaviyo-open');
		}
	}
});
